// layouts/PublicLayout.js
import { Outlet } from "react-router-dom";
import Header from "../components/Header";

const PublicLayout = ({ children }) => {
  return (
    <>
      <Header />
      <Outlet/>
    </>
  );
};

export default PublicLayout;
